import { useEffect } from 'react';

import { useSelectSubmitShoppingCartState } from 'src/hooks/use-submit-shopping-cart-mutation';
import { i18n } from 'src/i18n';

const beforeUnloadListener = (ev: BeforeUnloadEvent) => {
  ev.preventDefault();
  return (ev.returnValue = i18n.navigationLockMessage);
};

export const useNavPromptWhileOrdering = (): void => {
  const { isLoading, isError, isSuccess } = useSelectSubmitShoppingCartState();

  useEffect(() => {
    if (isLoading && !isSuccess) {
      window.addEventListener('beforeunload', beforeUnloadListener);
    } else if (isSuccess || isError) {
      window.removeEventListener('beforeunload', beforeUnloadListener);
    }
  }, [isSuccess, isError, isLoading]);
};
